import { Box } from '@mui/material'
import { buildHideActionsBranchProps } from './buildHideActionsBranchProps'
import { buildUserChatBubbleMorph } from './buildUserChatBubbleMorph'
import UserChatBubbleBottomActions from './UserChatBubbleBottomActions'
import UserChatBubbleGalleryOverlay from './UserChatBubbleGalleryOverlay'
import UserChatBubbleHideActionsBranch from './UserChatBubbleHideActionsBranch'
import UserChatBubbleReadReceipt from './UserChatBubbleReadReceipt'
import { useUserChatBubbleViewModel } from './useUserChatBubbleViewModel'

export default function UserChatBubbleView(props) {
  const vm = useUserChatBubbleViewModel(props)
  const morphBubble = buildUserChatBubbleMorph({
    isEditing: props.isEditing,
    attachments: props.attachments ?? [],
    attachmentState: vm.attachmentState,
    gallery: vm.gallery,
    draftText: props.draftText,
    onDraftTextChange: props.onDraftTextChange,
    onCancelEdit: props.onCancelEdit,
    onSendEdit: props.onSendEdit,
    replyTo: props.replyTo,
    onJumpToQuotedMessage: props.onJumpToQuotedMessage,
    children: props.children,
  })
  return (
    <Box className={vm.wrapClassName}>
      {vm.useFloatingActions ? (
        <UserChatBubbleHideActionsBranch {...buildHideActionsBranchProps(vm, props, morphBubble)} />
      ) : (
        morphBubble
      )}
      {props.readByUser && !props.isEditing ? <UserChatBubbleReadReceipt /> : null}
      {vm.showBottomActions ? (
        <UserChatBubbleBottomActions
          isEditing={props.isEditing}
          copied={vm.copied}
          handleCopy={vm.handleCopy}
          onEdit={props.onEdit}
          showVersionNav={props.showVersionNav}
          versionLabel={props.versionLabel}
          onPrevVersion={props.onPrevVersion}
          onNextVersion={props.onNextVersion}
          prevDisabled={props.prevDisabled}
          nextDisabled={props.nextDisabled}
        />
      ) : null}
      <UserChatBubbleGalleryOverlay gallery={vm.gallery} />
    </Box>
  )
}
